import { ADMIN_API } from "./adminApi";
import { ApiOk } from "./adminCommon.types";

export type ChangelogChange = { type: "feature" | "fix" | "improvement"; text: string };

export type ChangelogEntry = {
  id: number;
  version: string;
  releaseDate: string;
  changes: ChangelogChange[];
  published: boolean;
  createdAt: string;
};

export const listChangelog = async () => {
  const { data } = await ADMIN_API.get<ApiOk<ChangelogEntry[]>>("/api/admin/changelog");
  return data.data;
};

export const createChangelogEntry = async (payload: Partial<ChangelogEntry>) => {
  const { data } = await ADMIN_API.post<ApiOk<ChangelogEntry>>("/api/admin/changelog", payload);
  return data.data;
};

export const updateChangelogEntry = async (id: number, payload: Partial<ChangelogEntry>) => {
  const { data } = await ADMIN_API.put<ApiOk<ChangelogEntry>>(`/api/admin/changelog/${id}`, payload);
  return data.data;
};

export const deleteChangelogEntry = async (id: number) => {
  await ADMIN_API.delete(`/api/admin/changelog/${id}`);
};
